import {
  message as staticMessage,
  notification as staticNotification,
} from 'antd';

type AppApis = {
  message: typeof staticMessage;
  notification: typeof staticNotification;
  modal: any;
};

let cached: AppApis | null = null;

export function setAppApis(app: AppApis) {
  cached = app;
}

export function getAppApis(): AppApis {
  if (cached) return cached;
  // Fallback to static APIs to avoid breaking outside of App context
  return {
    message: staticMessage,
    notification: staticNotification,
    // @ts-ignore - only used where available
    modal: {} as any,
  } as unknown as AppApis;
}
